import React from 'react'
import useConfig from '../../../hooks/use-config'

const AppVersion = () => {
    const { version, env } = useConfig()
    return (
        <React.Fragment>v {version}-{env.charAt(0)}</React.Fragment>
    )
}

export default AppVersion